import { render, staticRenderFns } from "./XZCardRealName.vue?vue&type=template&id=541410f7&scoped=true&"
import script from "./XZCardRealName.vue?vue&type=script&lang=js&"
export * from "./XZCardRealName.vue?vue&type=script&lang=js&"
import style0 from "./XZCardRealName.vue?vue&type=style&index=0&id=541410f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541410f7",
  null
  
)

export default component.exports